import React from "react"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import { LandingPageFooter } from "../../components/LandingPageComponents/LandingPageFooter/LandingPageFooter"
import { LandingPageHeader } from "../../components/LandingPageComponents/LandingPageHeader/LandingPageHeader"
import { routeList } from "../../routes/routesIndex"

export const LayoutLoader = () => {
    return (
        <>
            <div className="" id="">
                <Router>
                    <LandingPageHeader />
                    <Routes>
                        {routeList.map((routeListItems, routeListKey) => {
                            return (
                                <Route key={`routeIndex${routeListKey}`} path={routeListItems.path} element={routeListItems.element} />
                            )
                        })}
                    </Routes>
                    <LandingPageFooter />
                </Router>
            </div>
        </>
    )
}